import { render, staticRenderFns } from "./RCompareWaterChart.vue?vue&type=template&id=905969a8&scoped=true"
import script from "./RCompareWaterChart.vue?vue&type=script&lang=ts"
export * from "./RCompareWaterChart.vue?vue&type=script&lang=ts"
import style0 from "./RCompareWaterChart.vue?vue&type=style&index=0&id=905969a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905969a8",
  null
  
)

export default component.exports